import { render } from "./ProjectTypeComponent.vue?vue&type=template&id=41372883&scoped=true&ts=true"
import script from "./ProjectTypeComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectTypeComponent.vue?vue&type=script&lang=ts"

import "./ProjectTypeComponent.vue?vue&type=style&index=0&id=41372883&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41372883"]])

export default __exports__